import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 222.1 239.04"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M195.1,184.8h-44.98c-1.66,0-3-1.34-3-3s1.34-3,3-3h44.98c11.58,0,21-9.42,21-21V27c0-11.58-9.42-21-21-21H27C15.42,6,6,15.42,6,27v130.8c0,11.58,9.42,21,21,21h44.98c1.66,0,3,1.34,3,3s-1.34,3-3,3H27c-14.89,0-27-12.11-27-27V27C0,12.11,12.11,0,27,0h168.1c14.89,0,27,12.11,27,27v130.8c0,14.89-12.11,27-27,27Z" />
        <path d="M56.07,132.94h-23.86c-1.66,0-3-1.34-3-3v-31.69c0-1.66,1.34-3,3-3h23.86c1.66,0,3,1.34,3,3v31.69c0,1.66-1.34,3-3,3ZM35.21,126.94h17.86v-25.69h-17.86v25.69Z" />
        <path d="M76.81,103.06c-1.66,0-3-1.34-3-3v-14.86c0-1.66,1.34-3,3-3h23.86c1.66,0,3,1.34,3,3v3.46c0,1.66-1.34,3-3,3s-3-1.34-3-3v-.46h-17.86v11.86c0,1.66-1.34,3-3,3Z" />
        <path d="M145.29,103.06c-1.66,0-3-1.34-3-3v-30.28h-17.86v18.88c0,1.66-1.34,3-3,3s-3-1.34-3-3v-21.88c0-1.66,1.34-3,3-3h23.86c1.66,0,3,1.34,3,3v33.28c0,1.66-1.34,3-3,3Z" />
        <path d="M189.89,132.94h-23.86c-1.66,0-3-1.34-3-3V40.78c0-1.66,1.34-3,3-3h23.86c1.66,0,3,1.34,3,3v89.17c0,1.66-1.34,3-3,3ZM169.03,126.94h17.86V43.78h-17.86v83.17Z" />
        <path d="M111.05,177.65c-20.13,0-36.5-16.37-36.5-36.5s16.37-36.5,36.5-36.5,36.5,16.37,36.5,36.5-16.37,36.5-36.5,36.5ZM111.05,110.65c-16.82,0-30.5,13.68-30.5,30.5s13.68,30.5,30.5,30.5,30.5-13.68,30.5-30.5-13.68-30.5-30.5-30.5Z" />
        <path d="M182.24,239.04c-1.09,0-2.14-.59-2.67-1.63-13.02-25.33-37.99-39.85-68.51-39.85s-55.52,14.53-68.53,39.85c-.76,1.48-2.57,2.05-4.04,1.3-1.47-.76-2.05-2.57-1.3-4.04,14.08-27.4,41-43.11,73.87-43.11s59.77,15.71,73.85,43.11c.76,1.47.18,3.28-1.3,4.04-.44.23-.91.33-1.37.33Z" />
      </g>
    </svg>
  )
}

export default Icon
